import { render, staticRenderFns } from "./transportation.vue?vue&type=template&id=ac12b24a&scoped=true&"
import script from "./transportation.vue?vue&type=script&lang=js&"
export * from "./transportation.vue?vue&type=script&lang=js&"
import style0 from "./transportation.vue?vue&type=style&index=0&id=ac12b24a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac12b24a",
  null
  
)

component.options.__file = "transportation.vue"
export default component.exports